const emailDeobfuscation = {
  emails: document.querySelectorAll(".js-obfuscate"),
  init() {
    if (this.emails) {
      this.emails.forEach((email) => {
        if (!email.hasAttribute("data-obfuscate")) {
          return;
        }

        const parentIsLink = email.parentElement.tagName === "A";

        const emailJson = JSON.parse(email.dataset.obfuscate);

        const mail = `${emailJson.local}@${emailJson.global}.${emailJson.endung}`;
        let title = document.createTextNode(mail);

        if (email.hasAttribute("data-title")) {
          title = document.createTextNode(email.dataset.title);
        }

        if (!parentIsLink) {
          const link = document.createElement("a"); // create the link-element
          link.setAttribute("href", "mailto:" + mail);
          link.setAttribute("class", email.classList);
          link.appendChild(title); // set the title
          email.innerHTML = ""; // empty the current fallback-message
          email.appendChild(link); // finally append the link-element to the span
        } else {
          email.parentElement.setAttribute("href", "mailto:" + mail);
          email.parentElement.appendChild(title); // set the title
          email.remove();
        }
      });
    }
  },
};

module.exports = emailDeobfuscation;
